import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#200211',
      color: '#00FFFF',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '5rem', margin: '0', color: '#FF33CC' }}>404</h1>
      <h2 style={{ fontSize: '2rem', margin: '20px 0' }}>Page non trouvée</h2>
      <p style={{ fontSize: '1.2rem', marginBottom: '30px' }}>
        Désolé, la page que vous recherchez n'existe pas sur MovieFrenzy.
      </p>
      <Link to="/" style={{
        backgroundColor: '#FF33CC',
        color: 'white',
        padding: '12px 30px',
        borderRadius: '30px',
        textDecoration: 'none',
        fontSize: '1.1rem',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(255, 51, 204, 0.3)'
      }}>
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default Error404; 